import { render, staticRenderFns } from "./rolemana.vue?vue&type=template&id=f702a3c2&scoped=true&"
import script from "./rolemana.vue?vue&type=script&lang=js&"
export * from "./rolemana.vue?vue&type=script&lang=js&"
import style0 from "./rolemana.vue?vue&type=style&index=0&id=f702a3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f702a3c2",
  null
  
)

export default component.exports